import {IAiChatPanel, SideTabKey} from '@/interface';
import * as store from '@/store';
import {isInKuShare} from '@/utils/urlUtils';

/**
 * panel状态初始化
 * @param aiChatPanel 当前从缓存或者store中取的数据
 * @param docGuid 文档id
 */
export function initPanelStatus(aiChatPanel?: IAiChatPanel, docGuid?: string) {
    const initData = aiChatPanel || store.getAiChatPanel();
    store.setAiChatPanel({
        ...initData,
        docGuid,
        isExternalNotComment: initData.selectedTab !== SideTabKey.Comment,
        showCommentBg: initData.isExpanded && initData.selectedTab === SideTabKey.Comment,
    });
}

/**
 * panel状态重置
 * @param defaultData 默认数据
 */
export function resetPanelStatus(defaultData: Partial<IAiChatPanel>) {
    store.setAiChatPanel({
        ...defaultData,
        selectedTab: SideTabKey.Comment,
        docGuid: '',
    });
}

/**
 * 打开面板
 * @param tab 当前选中的tab
 * @param isExternalNotComment 标识面板展开是由外部触发，而不是评论触发
 */
export function openPanel({
    tab,
    isExternalNotComment = false,
}: {tab?: SideTabKey, isExternalNotComment?: boolean}) {
    const aiChatPanel = store.getAiChatPanel();
    const preExpanded = aiChatPanel.isExpanded; // 面板在点击按钮之前是否展开
    store.setAiChatPanel({
        ...aiChatPanel,
        isExpanded: true,
        selectedTab: tab,
        isExternalNotComment: !preExpanded && isExternalNotComment, // 只有面板在点击按钮之前是关闭的，才需要将isExternalNotComment设为true
    });
}

/**
 * 关闭面板
 */
export function closePanel() {
    const aiChatPanel = store.getAiChatPanel();
    store.setAiChatPanel({
        ...aiChatPanel,
        isExpanded: false,
    });
}

/**
 * 划线评论背景重置
 */
export function resetCommentBg() {
    const aiChatPanel = store.getAiChatPanel();
    if (aiChatPanel.showCommentBg) {
        store.setAiChatPanel({
            ...aiChatPanel,
            showCommentBg: false,
        });
    }
}

/**
 * 处理编辑器划线评论展开/收起状态的通知
 * @param isExpanded 编辑器给到的划线评论面板展开状态
 */
export function handleCommentEvent(isExpanded: boolean) {
    const aiChatPanel = store.getAiChatPanel();
    const isCommentExpanded = isExpanded && !aiChatPanel.isExternalNotComment; // 排除外部触发的展开
    // ku享下直接使用value赋值到isExpanded上
    // 因为使用原先isExpanded: aiChatPanel.isExpanded || value，展开收起评论窗口时，监听不到评论窗口的状态
    // 非ku享保留原先逻辑isExpanded: aiChatPanel.isExpanded || value
    const isExpandedValue = isInKuShare() ? isExpanded : (aiChatPanel.isExpanded || isExpanded);
    store.setAiChatPanel({
        ...aiChatPanel,
        // isExpanded：保持展开状态 or 触发展开
        isExpanded: isExpandedValue,
        // selectedTab：展开时需要判断选中tab， 收起时保持原状
        selectedTab: isExpanded
            ? (isCommentExpanded ? SideTabKey.Comment : aiChatPanel.selectedTab)
            : aiChatPanel.selectedTab,
        isExternalNotComment: isExpanded ? false : aiChatPanel.isExternalNotComment,
    });
}
